import { OfferRecord, SiteLocale } from 'apps/website/types/dato';
import { useMemo } from 'react';
import { mapperOffer } from '../mappers/mapperOffer';

export const useMapOffers = ({
  offers,
  locale,
}: {
  offers?: OfferRecord[];
  locale: SiteLocale;
}) => {
  return useMemo(() => {
    const offersProps = offers
      ? offers.map((offer) => mapperOffer(offer, locale))
      : [];
    return offersProps;
  }, [offers, locale]);
};
